import { render } from "./ButtonBack.vue?vue&type=template&id=3827d7bc&scoped=true"
import script from "./ButtonBack.vue?vue&type=script&lang=js"
export * from "./ButtonBack.vue?vue&type=script&lang=js"

import "./ButtonBack.vue?vue&type=style&index=0&id=3827d7bc&lang=scss&scoped=true"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3827d7bc"]])

export default __exports__